import axios from 'axios'
import React, { useState, useContext } from 'react'
import { Form, Button, Modal, Alert, Row, Col, Spinner } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie'
import { AuthContext } from './AuthContext'
// import { Formik } from 'formik'
// import * as yup from 'yup'

const Login = ({
  currentUser,
  setCurrentUser,
  loginShow,
  setLoginShow,
  redirectTo,
  setRedirectTo,
}) => {
  const { baseUrl, sendDiscordNotification } = useContext(AuthContext)
  const loginUrl = '/api/crm/clinic/login'
  // const [AlertShow, setAlertShow] = useState(false)
  const [errShow, setErrShow] = useState({ show: false, msg: '' })

  const [password, setPassword] = useState('')
  // const [account, setAccount] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [loginSuccess, setLoginSuccess] = useState({ show: false, msg: '' })
  const [loginContent, setLoginContent] = useState({
    type: 1,
    inc_id: '',
    hosp_id: '',
    email: '',
  })
  const navigate = useNavigate()

  const expiresTime = parseFloat(process.env.REACT_APP_EXPIRES_TIME)
  const cookieOptions = { expires: expiresTime, secure: true }

  const handleClose = () => {
    setLoginShow(false)
    setPassword('')
    setErrShow({ show: false, msg: '' })
    setLoginSuccess({ show: false, msg: '' })
  }
  const handleShow = () => setLoginShow(true)

  const handleSubmit = (e) => {
    e.preventDefault()
    const requestBody = {
      type: loginContent.type,
      inc_id: loginContent.inc_id,
      hosp_id: loginContent.hosp_id,
      email: loginContent.email,
      password: password,
    }
    // console.log('requestBody', requestBody)
    if (
      (requestBody.type === 1 && requestBody.hosp_id === '') ||
      (requestBody.type === 2 && requestBody.email === '') ||
      requestBody.password === ''
    ) {
      setErrShow({ show: true, msg: '帳號或密碼不得空白' })
    } else {
      setIsLoading(true)
      axios
        .post(baseUrl + loginUrl, requestBody, {
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            Accept: '*/*',
          },
        })
        .then((res) => {
          // console.log('res', res)

          if (res.data.error?.code === '10110') {
            // 10110 = 驗證失敗
            setErrShow({ show: true, msg: '帳號或密碼錯誤' })
            setTimeout(() => {
              setErrShow({ show: false, msg: '' })
            }, 2000)
          } else if (res.data.error?.code === '10030') {
            setErrShow({ show: true, msg: '指定醫療機構不存在' })
            setTimeout(() => {
              setErrShow({ show: false, msg: '' })
            }, 2000)
          } else {
            const {
              hosp_id,
              inc_id,
              name,
              session,
              doctor_name,
              clinic_id,
              doctor_id,
            } = res.data
            const userData = res.data

            console.log('userData', userData)
            if (!Cookies.get('session')) {
              Cookies.set('session', JSON.stringify(userData), cookieOptions)
            }
            setTimeout(() => {
              setCurrentUser({
                hosp_id: hosp_id,
                inc_id: inc_id,
                name: name,
                doctor_name: doctor_name,
                session: session,
                clinic_id: clinic_id,
                doctor_id: doctor_id,
              })
              if (redirectTo) navigate(redirectTo)
            }, 1000)

            setLoginSuccess({
              show: true,
              msg: `歡迎回來！${doctor_name || name} `,
            })
          }
        })
        .catch((e) => {
          console.log('e', e)
          setErrShow({
            show: true,
            msg: '伺服器忙碌中，請稍後再試',
          })
          setTimeout(() => {
            setErrShow({ show: false, msg: '' })
          }, 5000)
          sendDiscordNotification(
            `登入失敗 \n Error: ${e}  \n RequestBody: ${requestBody.hosp_id}`
          )
        })
        .finally(() => {
          setIsLoading(false)
          setLoginShow(false)
        })
    }
  }

  // console.log('modal loginShow', loginShow)

  return (
    <>
      <div className="userButtonGroup">
        {!currentUser && (
          <Button
            variant="outline-primary login-button"
            className="me-2"
            onClick={handleShow}
          >
            登入
          </Button>
        )}

        {/* <Link to="/register">
          <Button variant="primary" className="text-white">
            註冊
          </Button>
        </Link> */}
      </div>

      <Modal
        show={loginShow}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>登入 HA! 健康數據管理平台</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            {/* <h5> 帳號(醫事機構代碼或統一編號擇一輸入)</h5> */}
            <Row>
              <Form.Group as={Col} className="mb-3" controlId="hosp_id">
                <div className="mb-2">
                  請選擇登入方式：
                  <Form.Check
                    inline
                    label="醫事機構代碼"
                    name="login-type"
                    type="radio"
                    id="radio-institution"
                    defaultChecked={true}
                    onChange={() =>
                      setLoginContent({
                        ...loginContent,
                        type: 1,
                      })
                    }
                  />
                  <Form.Check
                    inline
                    label="醫師 Email"
                    name="login-type"
                    type="radio"
                    id="radio-doctor"
                    onChange={() =>
                      setLoginContent({
                        ...loginContent,
                        type: 2,
                      })
                    }
                  />
                </div>
                <Form.Control
                  type="text"
                  placeholder={
                    loginContent.type === 1 ? 1234567890 : 'abc@gmail.com'
                  }
                  value={
                    loginContent.type === 1
                      ? loginContent.hosp_id
                      : loginContent.email
                  }
                  onChange={(e) => {
                    if (loginContent.type === 1) {
                      setLoginContent({
                        ...loginContent,
                        hosp_id: e.target.value.replace(/[^a-zA-Z0-9_]/g, ''),
                      })
                    } else if (loginContent.type === 2) {
                      setLoginContent({
                        ...loginContent,
                        email: e.target.value.replace(/[^a-zA-Z0-9_.@-]/g, ''),
                      })
                    }
                  }}
                />
              </Form.Group>
              {/* <Form.Group as={Col} className="mb-3" controlId="inc_id">
                <Form.Label>統一編號</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="12345678"
                  value={loginContent.inc_id}
                  onChange={(e) =>
                    setLoginContent({
                      ...loginContent,
                      inc_id: e.target.value,
                    })
                  }
                />
              </Form.Group> */}
            </Row>
            <Form.Group className="mb-3" controlId="password">
              <Form.Label>密碼</Form.Label>
              <Form.Control
                type="password"
                placeholder="請輸入密碼"
                value={password}
                onChange={(e) =>
                  setPassword(e.target.value.replace(/[^a-zA-Z0-9_]/g, ''))
                }
              />
            </Form.Group>
            <div className="noAccout mb-3">
              {/* <span className="text-secondary">還沒有帳號嗎? </span>{' '}
              <Link to="/register" onClick={handleClose}>
                建立新帳號
              </Link> */}
            </div>
            {errShow.show && (
              <Alert
                variant="danger"
                onClose={() => setErrShow({ show: false, msg: '' })}
                dismissible
                // className="visually-hidden"
              >
                <i className="fa-solid fa-triangle-exclamation"></i>{' '}
                {errShow.msg}
              </Alert>
            )}
            {loginSuccess.show && (
              <Alert
                variant="success"
                onClose={() => setLoginSuccess({ show: false, msg: '' })}
                dismissible
              >
                <i className="fa-regular fa-face-smile"></i>
                {'  '}
                {loginSuccess.msg}
              </Alert>
            )}
            <Button type="submit" className="w-100">
              登入{' '}
              <Spinner
                as="span"
                animation={isLoading ? 'border' : ''}
                size="sm"
                role="status"
                aria-hidden="true"
              />
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default Login
